import React, {useState} from 'react';
import { getCaseLabel, getCitationLabel } from "./lookupFunctions";
import { getCurrency } from "../global/utils";
import { dateIso2Us } from '../global/dateUtils';
import { useStyles    } from "../styles/styles";
import useTheme from "@mui/material/styles/useTheme";
import useMediaQuery from '@mui/material/useMediaQuery'
import ListItem from '@mui/material/ListItem';
import ListItemText from '@mui/material/ListItemText';
import Collapse from '@mui/material/Collapse';
import Grid from '@mui/material/Grid';
import Box from '@mui/material/Box';
import Button from '@mui/material/Button';
import Tooltip from '@mui/material/Tooltip'
import Zoom from '@mui/material/Zoom'

const PartyListItem = (props) => {
    const partyRec = props.partyRec;
    const court = props.court;
    const selectParty = props.selectParty;
    const classes = useStyles;
    const theme = useTheme();
    const smallScreen = useMediaQuery(theme.breakpoints.down('lg'));
    const [open, setOpen] = useState(false);

    const buttonLabel = () => {
        return open ? 'Hide' : 'Expand';
    }

    return (
        <ListItem alignItems='flex-start' sx={classes.listPadding}>
            <ListItemText
                sx={classes.listText}
                primary={
                    <Grid
                        container
                        spacing={2}
                        alignItems="top"
                        sx={{width: '100%'}}
                    >
                        {!smallScreen ? (
                            <>
                                <Grid item xs={3} lg={2}>
                                    <Tooltip title='Pay one or more balances for this party' TransitionComponent={Zoom} arrow>
                                        <Button
                                            variant='contained'
                                            color='success'
                                            onClick={() => selectParty(partyRec)}
                                            sx={classes.tinyButton}
                                        >
                                            Select
                                        </Button>
                                    </Tooltip>
                                </Grid>
                                <Grid item xs={5} lg={5}>
                                    {
                                        partyRec.party.partyName ? partyRec.party.partyName :
                                            `${partyRec.party.lastName}, ${partyRec.party.firstName}`
                                    }
                                </Grid>
                                <Grid item xs={4} lg={3}>
                                    {partyRec.party.dob && !court.hidePartyDob ? dateIso2Us(partyRec.party.dob) : ''}
                                </Grid>
                                <Grid item xs={12} lg={2}>
                                    <Box component='span' sx={{display: 'flex', flexDirection: 'row-reverse'}}>
                                        <Tooltip title='Show/hide the balances for this party' TransitionComponent={Zoom} arrow>
                                            <Button
                                                variant='contained'
                                                onClick={() => setOpen(!open)}
                                                sx={classes.tinyButton}
                                            >
                                                {buttonLabel()}
                                            </Button>
                                        </Tooltip>
                                    </Box>
                                </Grid>
                            </>
                        ) : (
                            <>
                                <Grid item xs={12}>
                                    {
                                        partyRec.party.partyName ? partyRec.party.partyName :
                                            `${partyRec.party.lastName}, ${partyRec.party.firstName}`
                                    }
                                </Grid>
                                <Grid item xs={12}>
                                    {partyRec.party.dob && !court.hidePartyDob ? dateIso2Us(partyRec.party.dob) : ''}
                                </Grid>
                                <Grid item xs={6} sx={{display: 'flex', justifyContent: 'flex-start'}}>
                                    <Tooltip title='Pay one or more balances for this party' TransitionComponent={Zoom} arrow>
                                        <Button
                                            variant='contained'
                                            color='success'
                                            onClick={() => selectParty(partyRec)}
                                            sx={classes.tinyButton}
                                        >
                                            Select
                                        </Button>
                                    </Tooltip>
                                </Grid>
                                <Grid item xs={6} sx={{display: 'flex', justifyContent: 'flex-end'}}>
                                    <Tooltip title='Show/hide the balances for this party' TransitionComponent={Zoom} arrow>
                                        <Button
                                            variant='contained'
                                            onClick={() => setOpen(!open)}
                                            sx={classes.tinyButton}
                                        >
                                            {buttonLabel()}
                                        </Button>
                                    </Tooltip>
                                </Grid>
                            </>
                        )}
                    </Grid>
                }
                primaryTypographyProps={{
                    component: 'span',
                    variant: 'subtitle1',
                    sx: classes.inline,
                    color: 'textPrimary'
                }}
                secondary={
                    <>
                        {partyRec.balances.map((balance) => {
                            return (
                                <Collapse in={open} timeout='auto' unmountOnExit>
                                    <Grid
                                        container
                                        spacing={2}
                                        alignItems="top"
                                        style={{width: '100%'}}
                                    >
                                        { !smallScreen &&
                                            <Grid lg={2}>&nbsp;</Grid>
                                        }
                                        <Grid item xs={6} lg={5}>
                                            {`${getCaseLabel(court)} ${balance.caseNumber}`}
                                        </Grid>
                                        { balance.citationNumber ?
                                            <Grid item xs={5} lg={3}>
                                                {`${getCitationLabel(court)} ${balance.citationNumber}`}
                                            </Grid>:
                                            <Grid item xs={5} lg={3}>
                                                &nbsp;
                                            </Grid>
                                        }
                                        <Grid item xs={0} lg={2}>&nbsp;</Grid>
                                        <Grid item xs={0} lg={2}>&nbsp;</Grid>
                                        <Grid item xs={12} lg={10} style={{paddingTop: '0'}}>
                                            {balance.description}
                                        </Grid>
                                        { !smallScreen &&
                                            <Grid item lg={2}>&nbsp;</Grid>
                                        }
                                        <Grid item xs={6} lg={5} sx={{marginBottom: '.5rem'}} style={{paddingTop: '0'}}>
                                            {!balance.ineligibleForPayment ? `Amount: ${getCurrency(balance.courtAmount)}`: ' '}
                                        </Grid>
                                        <Grid item xs={5} lg={3} sx={{marginBottom: '.5rem'}} style={{paddingTop: '0'}}>
                                            {`Status: ${balance.ineligibleForPayment ? 'Not payable' : (balance.disposed ? 'Assessed' : 'Pending')}`}
                                        </Grid>
                                    </Grid>
                                </Collapse>
                            );
                        })}
                    </>
                }
                secondaryTypographyProps={{
                    component: 'span',
                    variant: 'body2',
                    sx: classes.inline,
                    color: 'textPrimary'
                }}
            />
        </ListItem>
    );
}

export default PartyListItem;
